import  gql  from 'graphql-tag'

export const creditPurposes = gql`query creditPurposes($isActive: Boolean){ 
    creditPurposes(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
